import React from 'react';
import './styles.scss';

const BlockHeadlineWithIcon = ({ block }) => {
  const { headline, icon } = block;

  return (
    <div id="block-headline-with-icon">
      <div className="icon">
        <img src={icon.url} alt={icon.alt} />
      </div>

      <h4>{headline}</h4>
    </div>
  );
};

export default BlockHeadlineWithIcon;
